import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import InputSliderStepped from 'core/components/InputSliderStepped.vue'
import InputSelecionaBanco from 'core/components/InputSelecionaBanco.vue'
import ComprovantePagamentoModal from 'core/components/ComprovantePagamentoModal.vue'
import DadosEndereco from 'core/components/DadosEndereco.vue'
import DocumentoEdit from 'core/components/DocumentoEdit.vue'
import DocumentoModal from 'core/components/DocumentoModal.vue'
import DocumentoGrid from 'core/components/DocumentoGrid.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})
Vue.component('InputSliderStepped', InputSliderStepped)
Vue.component('InputSelecionaBanco', InputSelecionaBanco)
Vue.component('ComprovantePagamentoModal', ComprovantePagamentoModal)
Vue.component('DadosEndereco', DadosEndereco)
Vue.component('DocumentoEdit', DocumentoEdit)
Vue.component('DocumentoModal', DocumentoModal)
Vue.component('DocumentoGrid', DocumentoGrid)
